module.exports = __webpack_public_path__ + "img/app_card_example.f7cfdab0.png";